import cn from "@/util/cn"

export type BadgeVariant = "success" | "warning" | "error"

const badgeClassNames: Record<BadgeVariant, string> = {
  success: "bg-badge-success",
  warning: "bg-badge-warning",
  error: "bg-badge-error",
}

type BadgeIconProps = {
  variant: BadgeVariant
  className?: string
}

// Round colored badge with a circled check (success) or exclamation mark (warning, error)
const BadgeIcon = ({ variant, className }: BadgeIconProps) => (
  <div
    className={cn(
      "flex size-16 items-center justify-center rounded-full text-white",
      badgeClassNames[variant],
      className,
    )}
  >
    <svg
      aria-hidden
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="size-8"
    >
      <circle cx="12" cy="12" r="10" />
      {variant === "success" ? (
        <polyline points="7 12 11 16 17 9" />
      ) : (
        <>
          <line x1="12" y1="7" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12" y2="17" />
        </>
      )}
    </svg>
  </div>
)

export default BadgeIcon
